import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, FileDownIcon, SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const miniBadges = [{
  emoji: '📗',
  label: '6 Tomes'
}, {
  emoji: '🎁',
  label: '5 Bonuses'
}, {
  emoji: '📄',
  label: '300+ pages'
}, {
  emoji: '💬',
  label: '60+ session scripts'
}, {
  emoji: '✅',
  label: 'Works with any coaching method'
}];
const trustItems = [{
  Icon: LockIcon,
  label: 'Secure checkout'
}, {
  Icon: ZapIcon,
  label: 'Instant access'
}, {
  Icon: ShieldCheckIcon,
  label: '7-day guarantee'
}, {
  Icon: FileDownIcon,
  label: '100% PDF'
}];
export function Hero() {
  return <header className="w-full bg-cream" data-id="element-121" data-mp="s9gj46ak8sbc">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 pt-10 pb-14 sm:pt-16 sm:pb-20 text-center" data-id="element-122" data-mp="ncq1hej3xont">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-tint text-sage border border-sage-soft text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em]" data-id="element-123" data-mp="3d21rzwjzqin7">
          <SparklesIcon className="w-4 h-4 text-terracotta" aria-hidden="true" data-id="element-124" data-mp="3j8sezzr63hpb" />
          The Life Coach&apos;s Complete System™ — Trusted by hundreds of coaches
        </div>

        <h1 className="mt-7 font-serif font-black text-ink text-[34px] leading-[1.08] sm:text-5xl md:text-6xl tracking-tight" data-id="element-125" data-mp="3o59e1ozwngh6">
          Never Walk Into a Session{' '}
          <span className="text-sage" data-id="element-126" data-mp="3e7uw1kyc2jmr">Unprepared Again.</span>
        </h1>

        <p className="mt-6 text-ink-soft text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-127" data-mp="30hrjxmt646b1">
          The complete done-for-you system for life coaches — 60+ ready-to-run
          sessions, 29 professional worksheets, and word-for-word scripts
          covering every stage from Session Zero to graduation.{' '}
          <strong className="text-ink font-semibold" data-id="element-128" data-mp="2vjg6z37ktfol">
            You don&apos;t build it. It&apos;s already done for you.
          </strong>
        </p>

        <div className="mt-9 max-w-3xl mx-auto" data-id="element-129" data-mp="2lkiks6xmhy8r">
          <img src="https://cdn.magicpatterns.com/uploads/gFv1QmhhktSnb3vBqwXjb9/hf_20260727_184724_c5aeade3-061a-474f-aa36-15ec8e8420dd.png" alt="The Life Coach's Complete System shown across desktop, tablet, and phone — 6 tomes, session scripts, coach's toolkit, and action plan workbook" className="w-full h-auto mix-blend-multiply" width={1024} height={1024} loading="eager" data-id="element-130" data-mp="2lk8wqow5215p" />
        </div>

        <div className="flex justify-center" data-id="element-131" data-mp="1azumrik0svzh">
          <CtaButton data-id="element-132" data-mp="1ayjilhmnxm7u">GET MY COMPLETE SYSTEM</CtaButton>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-133" data-mp="162cabi6snymq">
          {trustItems.map(({
          Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 text-sm font-medium text-ink-soft" data-id="element-134" data-mp="114kj6qdz4gjl">
              <Icon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-135" data-mp="3lt76ct9j5vvb" />
              {label}
            </li>)}
        </ul>

        <ul className="mt-10 flex flex-wrap justify-center gap-2" data-id="element-136" data-mp="3hpsgzbzpc357">
          {miniBadges.map(badge => <li key={badge.label} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-cream-dark px-3.5 py-2 text-xs sm:text-sm font-medium text-ink" data-id="element-137" data-mp="1xb5mo58pibbw">
              <span aria-hidden="true" data-id="element-138" data-mp="2b0pmp3awkuhi">{badge.emoji}</span>
              {badge.label}
            </li>)}
        </ul>
      </div>
    </header>;
}